import {Dropdown as _Dropdown} from '~/components/dropdown/components/dropdown'
import {DropdownItem} from '~/components/dropdown/components/dropdown_item'
import {t} from '@eitje/bridge'
import {moveColumn, groupColumn, hideColumn, pinOrUnpinColumn} from '../../../actions'

export const Dropdown = ({trigger, header, ...rest}) => {
	'use no memo'
	// Table taxonomy
	const {column, getContext, id: columnName} = header
	const {getIsSorted, getIsPinned, getCanSort, getCanPin, getIsGrouped} = column
	const context = getContext()
	const {
		getLeftLeafColumns,
		setSorting,
		getCenterFlatHeaders,
		getVisibleLeafColumns,
		options: {
			meta: {tableName},
		},
	} = context.table

	// Sorting columns
	const canSort = getCanSort()
	const sortDirection = getIsSorted()
	const isGroupedColumn = getIsGrouped()

	// Pinned columns
	const isPinned = getIsPinned()
	const pinnedColumns = getLeftLeafColumns?.()._map('id')

	// Column positions
	const visibleColumns = getVisibleLeafColumns()
	const unpinnedColumns = getCenterFlatHeaders()._map('id')
	const leftmostPinned = isPinned && pinnedColumns[0] === columnName
	const leftmostUnpinned = unpinnedColumns[0] === columnName
	const rightmostPinned = isPinned && _.last(pinnedColumns) === columnName
	const rightmostUnpinned = _.last(unpinnedColumns) === columnName

	return (
		<_Dropdown triggerEvent="click" placement="bottom" trigger={trigger}>
			{canSort && (
				<DropdownItem
					iconLeft="arrow-up"
					t="table.sort"
					onClick={() => setSorting([{id: columnName, desc: false}])}
					disabled={sortDirection === 'asc' && {key: 'table.already_sorted', direction: t('common.ascending')}}
				/>
			)}
			{canSort && (
				<DropdownItem
					iconLeft="arrow-down"
					t="table.sort"
					onClick={() => setSorting([{id: columnName, desc: true}])}
					disabled={sortDirection === 'desc' && {key: 'table.already_sorted', direction: t('common.descending')}}
				/>
			)}
			{getCanPin() && (
				<DropdownItem
					iconLeft="push-pin"
					t={`table.${isPinned ? 'unpin' : 'pin'}`}
					disabled={pinnedColumns.length === 1 && isPinned ? 'table.cant_unpin_only' : isGroupedColumn && 'table.cant_unpin_grouped'}
					onClick={() => pinOrUnpinColumn({tableName, header, pinnedColumns})}
				/>
			)}
			<DropdownItem
				iconLeft="list"
				t={`table.${isGroupedColumn ? 'ungroup' : 'group'}`}
				onClick={() => groupColumn({tableName, isGroupedColumn, columnName})}
			/>
			<DropdownItem
				iconLeft="arrow-left"
				t="table.move"
				disabled={
					leftmostUnpinned
						? 'table.move_over_grouped'
						: isGroupedColumn
							? 'table.cant_move_grouped'
							: leftmostPinned && 'table.cant_move_column'
				}
				onClick={() => moveColumn({direction: 'left', header, context, isPinned})}
			/>
			<DropdownItem
				iconLeft="arrow-right"
				t="table.move"
				disabled={
					isGroupedColumn
						? 'table.cant_move_grouped'
						: rightmostPinned
							? 'table.unpin_column_to_move_right'
							: rightmostUnpinned && 'table.cant_move_column'
				}
				onClick={() => moveColumn({direction: 'right', header, context, isPinned})}
			/>
			<DropdownItem
				iconLeft="eye-closed"
				t="table.hide"
				disabled={isGroupedColumn ? 'table.cant_hide_grouped' : visibleColumns.length < 2 && 'table.cant_hide_all'}
				onClick={() => hideColumn({visibleColumns, header, tableName})}
			/>
		</_Dropdown>
	)
}
